/**
 * Top-level fallback rendered by Sentry.ErrorBoundary when the app throws a
 * render-time error. Replaces the previous "blank white screen" failure mode.
 *
 * Closes Phase 2 audit priority #17.
 */

interface AppErrorFallbackProps {
  onReset: () => void;
}

export function AppErrorFallback({ onReset }: AppErrorFallbackProps) {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        backgroundColor: '#0b0b0c',
        color: '#f5f5f5',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <div style={{ maxWidth: '480px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.5rem', margin: '0 0 0.75rem', fontWeight: 600 }}>
          Something went wrong
        </h1>
        <p style={{ margin: '0 0 1.5rem', opacity: 0.7, lineHeight: 1.5 }}>
          The page hit an unexpected error. We&rsquo;ve been notified. You can try again, or reload
          the page if the issue persists.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
          <button
            onClick={onReset}
            style={{
              padding: '0.625rem 1.25rem',
              borderRadius: '0.5rem',
              border: '1px solid rgba(255,255,255,0.15)',
              background: 'transparent',
              color: '#f5f5f5',
              cursor: 'pointer',
              fontSize: '0.875rem',
            }}
          >
            Try again
          </button>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '0.625rem 1.25rem',
              borderRadius: '0.5rem',
              border: 'none',
              background: '#f5f5f5',
              color: '#0b0b0c',
              cursor: 'pointer',
              fontSize: '0.875rem',
              fontWeight: 500,
            }}
          >
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
}
